import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { useEffect, useState } from 'react';
import { CheckIcon } from 'utils/SVGIcons';

interface IconCheckMotionProps {
  size?: number;
  isChecked: boolean;
  animate?: boolean;
  animateDelay?: number;
  onClick?: () => void;
}

const IconCheckMotion = ({
  animate = false,
  size = 14,
  animateDelay = 0,
  isChecked,
  onClick,
}: IconCheckMotionProps) => {
  const [isAnimate, setIsAnimate] = useState(false);

  const handleClick = () => {
    onClick?.();
  };

  useEffect(() => {
    if (isChecked) return;

    const timeoutId = setTimeout(() => {
      setIsAnimate(animate);
    }, animateDelay);

    return () => clearTimeout(timeoutId);
  }, [animate, animateDelay, isChecked]);

  useEffect(() => {
    if (!animate) {
      setIsAnimate(false);
    }
  }, [animate]);

  if (!isAnimate) {
    return (
      <span onClick={handleClick}>
        <CheckIcon
          size={size}
          color={isChecked ? 'var(--seed-scale-color-carrot-500)' : 'var(--seed-scale-color-gray-500)'}
        />
      </span>
    );
  }

  return (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <StyledPath
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.64666 5.98808C1.40993 6.2066 1.39517 6.57565 1.61369 6.81238L5.69702 11.1874C5.81583 11.3161 5.98619 11.3846 6.16104 11.374C6.33588 11.3634 6.4967 11.2747 6.59905 11.1326L12.4324 3.25756C12.6206 2.99612 12.5613 2.63157 12.2998 2.44333C12.0384 2.25508 11.6738 2.31443 11.4856 2.57588L6.0697 9.87109L2.47096 6.02106C2.25244 5.78433 1.88339 5.76957 1.64666 5.98808Z"
        fill="var(--seed-scale-color-carrot-500)"
      />
    </svg>
  );
};

export default IconCheckMotion;

const fillIn = keyframes`
  from {
    fill: transparent;
  }
  to {
    fill: var(--seed-scale-color-carrot-500);
  }
`;

const StyledPath = styled.path`
  animation: ${fillIn} 0.3s ease forwards;
`;
